import { render, staticRenderFns } from "./FlightView.vue?vue&type=template&id=23c8b2a0&"
import script from "./FlightView.vue?vue&type=script&lang=js&"
export * from "./FlightView.vue?vue&type=script&lang=js&"
import style0 from "./FlightView.vue?vue&type=style&index=0&id=23c8b2a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports